import { cn } from "@/lib/cn";
import type { CSSProperties } from "react";

export interface BgGlowProps {
  /** Neon color for the radial gradient center */
  color?: string;
  /** Diameter of the glow circle in px */
  size?: number;
  /** Opacity of the glow (0-1) */
  opacity?: number;
  className?: string;
  style?: CSSProperties;
}

/**
 * Soft radial gradient bloom used as a decorative background element
 * behind hero sections (e.g. the globus area). Always aria-hidden.
 */
export function BgGlow({
  color = "var(--iris-neon-magenta)",
  size = 600,
  opacity = 0.25,
  className,
  style,
}: BgGlowProps) {
  return (
    <div
      aria-hidden
      className={cn(className)}
      style={{
        position: "absolute",
        width: size,
        height: size,
        borderRadius: "50%",
        background: `radial-gradient(circle, ${color} 0%, transparent 65%)`,
        opacity,
        filter: "blur(40px)",
        pointerEvents: "none",
        ...style,
      }}
    />
  );
}
